var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFacebook = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C12.9167 0 13.2708 0.145833 13.5625 0.4375C13.8542 0.729167 14 1.08333 14 1.5V12.5C14 12.9167 13.8542 13.2708 13.5625 13.5625C13.2708 13.8542 12.9167 14 12.5 14H8.21875V9.25H10.0312L10.375 7H8.21875V5.53125C8.21875 4.73958 8.63542 4.34375 9.46875 4.34375H10.4375V2.4375C9.85417 2.33333 9.28125 2.28125 8.71875 2.28125C8.11458 2.28125 7.59375 2.39583 7.15625 2.625C6.73958 2.85417 6.40625 3.19792 6.15625 3.65625C5.90625 4.11458 5.78125 4.65625 5.78125 5.28125V7H3.8125V9.25H5.78125V14H1.5C1.08333 14 0.729167 13.8542 0.4375 13.5625C0.145833 13.2708 0 12.9167 0 12.5V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0H12.5Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/facebook.2e910b1a.svg";
export { ForwardRef as ReactComponent };